module.exports = __webpack_public_path__ + "static/img/cchj4.55badce2.png";